import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
export function ButtonEdit(props) {
  return /*#__PURE__*/React.createElement(_Button, _extends({
    type: "primary",
    size: "small"
  }, props), "\u7F16\u8F91");
}